import {
  businessServiceTypeValues,
  ServiceOrderType,
} from "@/_constants/serviceOrder";
import Analysis from "@/assets/svg/Business/Analysis";
import Building from "@/assets/svg/Business/Building";
import BuyHouse from "@/assets/svg/Business/BuyHouse";
import House from "@/assets/svg/Business/House";
import HouseConfig from "@/assets/svg/Business/HouseConfig";
import { BusinessServiceType } from "@/common/enums/sharedEnums";

export const TOGGLE_CREATE_SERVICES = "TOGGLE_CREATE_SERVICES";
export const TOGGLE_CREATE_ERP = "TOGGLE_CREATE_ERP";

export const GET_SERVICES_AGENDA_TEAM = "GET_SERVICES_AGENDA_TEAM";
export const GET_SERVICES_AGENDA_TEAM_SUCCESS =
  "GET_SERVICES_AGENDA_TEAM_SUCCESS";
export const GET_SERVICES_AGENDA_TEAM_FAILED =
  "GET_SERVICES_AGENDA_TEAM_FAILED";

export const businessServiceTypeLabels = {
  [BusinessServiceType.RENTAL_MANAGEMENT]: businessServiceTypeValues[0].label,
  [BusinessServiceType.CONDOMINIUM_MANAGEMENT]:
    businessServiceTypeValues[1].label,
  [BusinessServiceType.PROPERTY_SALES]: businessServiceTypeValues[2].label,
  [BusinessServiceType.RENOVATION_DEVELOPMENT]:
    businessServiceTypeValues[3].label,
  [BusinessServiceType.ERP_EXPRESS]: businessServiceTypeValues[4].label,
};

export const businessServiceTypeLabelsMin = {
  [BusinessServiceType.RENTAL_MANAGEMENT]:
    businessServiceTypeValues[0].labelMin,
  [BusinessServiceType.CONDOMINIUM_MANAGEMENT]:
    businessServiceTypeValues[1].labelMin,
  [BusinessServiceType.PROPERTY_SALES]: businessServiceTypeValues[2].labelMin,
  [BusinessServiceType.RENOVATION_DEVELOPMENT]:
    businessServiceTypeValues[3].labelMin,
  [BusinessServiceType.ERP_EXPRESS]: businessServiceTypeValues[4].labelMin,
};

export const serviceTypes = [
  {
    id: BusinessServiceType.RENTAL_MANAGEMENT,
    title: "Gestion / location",
    subtitle: "Commandez vos états des lieux, chiffrage, diagnostics",
    icon: House,
    enabled: true,
  },
  {
    id: BusinessServiceType.CONDOMINIUM_MANAGEMENT,
    title: "Syndic de copropriété",
    subtitle: "Commandez vos PPPT, visite d'immeuble, diagnostics",
    icon: Building,
    enabled: true,
  },
  {
    id: BusinessServiceType.PROPERTY_SALES,
    title: "Transaction immobilière",
    subtitle: "Commandes vos diagnostics avant vente",
    icon: BuyHouse,
    enabled: true,
  },
  {
    id: BusinessServiceType.RENOVATION_DEVELOPMENT,
    title: "Promotion - Rénovation",
    subtitle: "Commandez vos diagnostics avant travaux, DPE neufs",
    icon: HouseConfig,
    enabled: true,
  },
  {
    id: BusinessServiceType.ERP_EXPRESS,
    title: "ERP Express",
    subtitle: "Pour vos ERP en 1 clic",
    icon: Analysis,
    enabled: true,
  },
];

const rentalManagementServices = [
  {
    label: "Sortie",
    value: ServiceOrderType.OUTGOING_INVENTORY,
    defaultValue: true,
  },
  {
    label: "Sortie + Chiffrage",
    value: ServiceOrderType.OUTGOING_INVENTORY_WITH_COSTING,
  },
  { label: "Entrée", value: ServiceOrderType.INCOMING_INVENTORY },
  {
    label: "Sortie / Entrée",
    value: ServiceOrderType.OUTGOING_INCOMING_INVENTORY,
  },
  { label: "Diagnostic", value: ServiceOrderType.DIAGNOSTIC },
];

export const condominiumManagementServices = [
  { label: "Visite Immeuble", value: ServiceOrderType.CONDOMINIUM_VISIT },
  { label: "PPPT", value: ServiceOrderType.PPPT },
  { label: "Diagnostic", value: ServiceOrderType.DIAGNOSTIC },
];

export const propertySalesServices = [
  { label: "Diagnostic", value: ServiceOrderType.DIAGNOSTIC },
  { label: "Audit énergétique", value: ServiceOrderType.ENERGY_AUDIT },
  {
    label: "Création Copropriété",
    value: ServiceOrderType.CONDOMINIUM_CREATION,
  },
  { label: "ERP express", value: ServiceOrderType.ERP_EXPRESS },
];

export const renovationDevelopmentServices = [
  { label: "Diagnostic", value: ServiceOrderType.DIAGNOSTIC },
];

export const erpExpressServices = [
  {
    label: "ERP express",
    value: ServiceOrderType.ERP_EXPRESS,
  },
];

export const servicesByBusinessType = {
  [BusinessServiceType.RENTAL_MANAGEMENT]: rentalManagementServices,
  [BusinessServiceType.CONDOMINIUM_MANAGEMENT]: condominiumManagementServices,
  [BusinessServiceType.PROPERTY_SALES]: propertySalesServices,
  [BusinessServiceType.RENOVATION_DEVELOPMENT]: renovationDevelopmentServices,
  [BusinessServiceType.ERP_EXPRESS]: erpExpressServices,
};
